import { render } from "./CheckoutProducts.vue?vue&type=template&id=7168c4cb&ts=true&lang=pug"
import script from "./CheckoutProducts.vue?vue&type=script&setup=true&lang=ts"
export * from "./CheckoutProducts.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__